import React from 'react';
import Content from '../components/Content';

// Definición del componente funcional
const USAmap = () => {
  return (

    <div className="flex justify-center">
        <img className="w-full max-w-[900px]" src="./usa-map.jpg" alt="Mapa de los Estados Unidos" />
    </div>

  );
};

export default USAmap;